export default {
  loading: {
    marginLeft: "5px",
    zIndex: 1000
  },
  img: {
    zIndex: 30,
    height: "30px",
    width: "30px",
  },
};



// WEBPACK FOOTER //
// ./src/components/Common/Loader/FieldLoader/fieldLoader.style.js